<template>
  <div id="statusView">
    <div v-if="$route.name === 'status'">
      <b-col lg="12" style="padding-left: 0px;">
        <h1>{{ $t('privatePage.status_header') }}</h1>
        <status-page :tests="tests"
                     :pdfRequirements="pdfRequirements"
                     :currentUser="currentUser"
                     v-on:onDeleteTest="onDeleteTest"
                     v-on:onUpdateTestSuiteExpireDate="onUpdateTestSuiteExpireDate"
                     v-on:onGetPdfRequirements="onGetPdfRequirements"
                     v-on:onGetPdfRequirementsTeamProfile="onGetPdfRequirementsTeamProfile"
                     v-on:onGeneratePdf="onGeneratePdf"
                     v-on:onGenerateMultiPdf="onGenerateMultiPdf"
                     v-on:onGenerateExpertReport="onGenerateExpertReport"
                     v-on:onGenerateExpertTeamReport="onGenerateExpertTeamReport">
        </status-page>

      </b-col>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import statusPage from '../../components/status/statuspage'

export default {
  components: {
    statusPage
  },
  data() {
    return {
      pdfRequirements: {},
      currentUser: {}
    }
  },
  computed: {
    ...mapGetters(['userId']),
    ...mapGetters('testSuitesModule', ['tests'])
  },
  methods: {
    ...mapActions({
      showSuccessMessage: 'showSuccessMessage',
      showErrorMessage: 'showErrorMessage'
    }),
    ...mapActions('testSuitesModule', {
      getTests: 'getTests',
      deleteTest: 'deleteTest',
      updateTestSuiteExpireDate: 'updateTestSuiteExpireDate',
      getPdfRequirements: 'getPdfRequirements',
      getPdfRequirementsTeamProfile: 'getPdfRequirementsTeamProfile',
      generatePdf: 'generatePdf',
      generateMultiPdf: 'generateMultiPdf'
    }),
    ...mapActions('userGroupsModule', {
      getMyCompany: 'getMyCompany',
      getUser: 'getUser'
    }),
    onUpdateTestSuiteExpireDate(test) {
      this.updateTestSuiteExpireDate(test)
        .then(() => {
          this.showSuccessMessage(this.$t('save_ok_feedback'))
        })
        .catch(error => {
          this.showErrorMessage(error)
        })
    },
    onDeleteTest(testId) {
      if (
        window.confirm(this.$t('privatePage.testDelete_confirmation'))
      ) {
        this.deleteTest({ userId: this.userId, testId })
          .then(() => {
            this.showSuccessMessage(
              this.$t('privatePage.testDelete_message')
            )
          })
          .catch(() => {
            this.showErrorMessage(
              this.$t('privatePage.testDelete_error_message')
            )
          })
      }
    },
    onSelectTest(testId) {
      window.confirm(this.$t('privatePage.testDelete_confirmation'))
    },
    onResetPdfRequirements() {
      this.pdfRequirements = {}
    },
    onGetPdfRequirements(test) {
      this.pdfRequirements = {}

      this.getPdfRequirements({ testId: test.testId, userId: this.userId })
        .then(requirements => {
          this.pdfRequirements = requirements
          this.getMyCompany()
        })
        .catch(error => {
          this.showErrorMessage(error)
        })
    },
    onGetPdfRequirementsTeamProfile(testIds) {
      this.pdfRequirements = {}

      this.getPdfRequirementsTeamProfile({ testIds: testIds, userId: this.userId })
        .then(requirements => {
          this.pdfRequirements = requirements
          this.getMyCompany()
        })
        .catch(error => {
          this.showErrorMessage(error)
        })
    },
    onGeneratePdf(pdfSettings) {
      pdfSettings.userId = this.userId
      pdfSettings.reportId = ''
      this.generatePdf(pdfSettings).catch(error => {
        if (error.status === 403) {
          this.showErrorMessage(
            this.$t('privatePage.stringEMInsufficientCredits')
          )
        } else {
          this.showErrorMessage(this.$t('errorMessage_server'))
        }
      })
    },
    onGenerateMultiPdf(pdfSettings) {
      pdfSettings.userId = this.userId
      pdfSettings.reportId = ''
      this.generateMultiPdf(pdfSettings).catch(error => {
        if (error.status === 403) {
          this.showErrorMessage(
            this.$t('privatePage.stringEMInsufficientCredits')
          )
        } else {
          this.showErrorMessage(this.$t('errorMessage_server'))
        }
      })
    },
    onGenerateExpertReport(pdfSettings) {
      pdfSettings.userId = this.userId
      pdfSettings.isExpertReport = true
      this.generatePdf(pdfSettings).then(() => {
        if (pdfSettings.onComplete) {
          pdfSettings.onComplete(true)
        }
      }).catch(error => {
        if (error.status === 403) {
          this.showErrorMessage(
            this.$t('privatePage.stringEMInsufficientCredits')
          )
        } else {
          this.showErrorMessage(this.$t('errorMessage_server'))
        }
        pdfSettings.onComplete(false)
      })
    },
    onGenerateExpertTeamReport(pdfSettings) {
      pdfSettings.userId = this.userId
      pdfSettings.isExpertReport = true
      this.generateMultiPdf(pdfSettings).catch(error => {
        if (error.status === 403) {
          this.showErrorMessage(
            this.$t('privatePage.stringEMInsufficientCredits')
          )
        } else {
          this.showErrorMessage(this.$t('errorMessage_server'))
        }
      })
    }
  },
  created() {
    this.getUser().then(user => {
      this.currentUser = user
    })
    this.getTests(this.userId)
      .then(() => {})
      .catch(() => {})
  }
}
</script>
